import { TTBackboneView } from '@/views/TTBackboneView';

export class QuickPunchBaseViewController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	// Initialize shared Quick Punch tooltip state so validation cleanup can be reused safely across controllers.
	initialize( options ) {
		super.initialize( options );
		this.edit_view_error_ui_dic = {};
		this.error_tip_timeout_ids = {};
	}

	// Hide the initial validation flash after a short delay while preserving hover/focus behavior on invalid fields.
	scheduleErrorTipHide( key, field_obj ) {
		if ( this.error_tip_timeout_ids[key] ) {
			clearTimeout( this.error_tip_timeout_ids[key] );
		}

		this.error_tip_timeout_ids[key] = setTimeout( () => {
			const tooltip = bootstrap.Tooltip.getInstance( field_obj[0] );
			if ( tooltip && field_obj.hasClass( 'is-invalid' ) ) {
				tooltip.hide();
			}
		}, 1500 );
	}

	// Reuse the same tooltip instance so repeated validation on the same field does not race Bootstrap disposal.
	showErrorTip( key, field_obj, error_string ) {
		field_obj.addClass( 'is-invalid' );
		field_obj[0].setAttribute( 'data-bs-original-title', error_string );

		const tooltip = bootstrap.Tooltip.getOrCreateInstance( field_obj[0], {
			title: error_string,
			placement: 'top',
			trigger: 'hover focus'
		} );

		tooltip.enable();
		tooltip.setContent( { '.tooltip-inner': error_string } );
		tooltip.show();
		this.scheduleErrorTipHide( key, field_obj );
		this.edit_view_error_ui_dic[key] = field_obj;
	}

	// Hide and disable a validation tooltip without disposing it so Bootstrap's delayed callbacks remain safe.
	clearErrorTip( key, clear_all ) {
		const field_obj = this.edit_view_error_ui_dic[key];
		if ( !field_obj || !field_obj[0] ) {
			delete this.edit_view_error_ui_dic[key];
			return;
		}

		const tooltip_element = field_obj[0];
		if ( !clear_all && tooltip_element.value === '' ) {
			return;
		}

		if ( this.error_tip_timeout_ids[key] ) {
			clearTimeout( this.error_tip_timeout_ids[key] );
			delete this.error_tip_timeout_ids[key];
		}

		field_obj.removeClass( 'is-invalid' );

		const tooltip = bootstrap.Tooltip.getInstance( tooltip_element );
		if ( tooltip ) {
			tooltip.hide();
			tooltip.disable();
		}

		tooltip_element.removeAttribute( 'aria-describedby' );
		tooltip_element.removeAttribute( 'data-bs-original-title' );
		delete this.edit_view_error_ui_dic[key];
	}

	// Clear all tracked Quick Punch validation tooltips using the shared non-disposing lifecycle.
	clearErrorTips( clear_all ) {
		Object.keys( this.edit_view_error_ui_dic ).forEach( key => {
			this.clearErrorTip( key, clear_all );
		} );
		this.edit_view_error_ui_dic = {};
	}

	// getRequiredFiles() {
	// 	//override in child class
	// 	return [];
	// }

	/**
	 * When changing this function, you need to look for all occurences of this function because it was needed in several bases
	 * BaseViewController, HomeViewController, BaseWizardController, QuickPunchBaseViewControler
	 *
	 * @returns {Array}
	 */
	// filterRequiredFiles() {
	// 	var retval = [];
	// 	var required_files;
	//
	// 	if ( typeof this._required_files == 'object' ) {
	// 		required_files = this._required_files;
	// 	} else {
	// 		required_files = this.getRequiredFiles();
	// 	}
	//
	// 	if ( required_files && required_files[0] ) {
	// 		retval = required_files;
	// 	} else {
	// 		for ( var edition_id in required_files ) {
	// 			if ( Global.getProductEdition() >= edition_id ) {
	// 				retval = retval.concat( required_files[edition_id] );
	// 			}
	// 		}
	// 	}
	//
	// 	Debug.Arr( retval, 'RETVAL', 'BaseViewController.js', 'BaseViewController', 'filterRequiredFiles', 10 );
	// 	return retval;
	// }
}
